/**
 * ObjectJsonField React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';

// application
import JsonEditor from '../base/JsonEditor';


/**
 * ObjectJsonField is an editing component for JSON fields of objects
 *
 * @author Jens Gruschel
 */
export class ObjectJsonField extends React.Component {

    render() {

        const { fieldDef } = this.props;

        return <JsonEditor
            label={fieldDef.name}
            helperText={fieldDef.note}
            value={this.props.value}
            readOnly={this.props.readOnly}
            onChange={value => this.props.onObjectValueChange(this.props.fieldDef.id, value)}
        />;
    }
}

ObjectJsonField.propTypes = {
    onObjectValueChange: PropTypes.func.isRequired,
    fieldDef: PropTypes.object.isRequired,
    objectId: PropTypes.string,
    readOnly: PropTypes.bool,
    value: PropTypes.any
};

export default ObjectJsonField;